import { WEB_PLAYER_CONTEXT_MENUS } from './available-context-menus';
const ɵ0 = WEB_PLAYER_CONTEXT_MENUS;
export class WebPlayerModule {
}
export { ɵ0 };
